/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Work_Activity_File_Unsupported_TypeInputs */

const vi_error_work_activity_file_unsupported_type = /** @type {(inputs: Error_Work_Activity_File_Unsupported_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tệp không đúng loại. Chỉ nhận PDF, Word, Excel hoặc ảnh jpg, png, webp.`)
};

/**

* @param {Error_Work_Activity_File_Unsupported_TypeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_work_activity_file_unsupported_type = /** @type {((inputs?: Error_Work_Activity_File_Unsupported_TypeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Work_Activity_File_Unsupported_TypeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_work_activity_file_unsupported_type(inputs)
});